import React from 'react';
import ReactDOM from 'react-dom/client';
import "./index.scss"
import App from './App';
import reportWebVitals from './reportWebVitals';
import './css/ui/Card.scss'
import './css/ui/Button.scss'
import './css/ui/Theme.scss'




const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);


reportWebVitals();
